import React, { useMemo, useEffect } from "react";
import SFFilterChips from "../chip/filterChips";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { gridLayoutActions } from "../../redux/reducers/gridLayoutReducer";

const GridFilterChips = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const savedLayout = useSelector((state) => {
    return state.clientSideFilter.find(
      (clientSideFilter) => clientSideFilter.gridName === props.gridName
    );
  });

  useEffect(() => {
    if (savedLayout?.state) {
      dispatch(
        gridLayoutActions.saveState({
          gridName: props.gridName,
          state: savedLayout.state,
        })
      );
    }
  }, [JSON.stringify(savedLayout?.state)]);

  const mappedFilters = useMemo(() => {
    const filterModel = savedLayout?.state?.filter?.filterModel || {};
    let items = Object.entries(filterModel || {}).flatMap(([key, value]) => {
      if (value.values)
        return value.values.map((val) => ({ label: key, value: val }));
      else return { label: key, value: key };
    });
    if (props.getSearchChipDetail) {
      return items.map((a) => props.getSearchChipDetail(a));
    }
    return items;
  }, [JSON.stringify(savedLayout?.state?.filter)]);

  return (
    <SFFilterChips
      items={mappedFilters}
      variant="primary"
      onDelete={(item) => {
        if (item.value === item.field) {
          let filterModel = savedLayout?.state?.filter?.filterModel;
          let newFilterModel = { ...filterModel, [item.field]: {} };
          props.changeFilterModel(newFilterModel);
          return;
        }
        let currentValues =
          savedLayout?.state?.filter?.filterModel[item.field].values;
        let newValues = currentValues.filter((a) => a !== item.value);

        let filterModel = {
          [item.field]: { filterType: "set", values: newValues },
        };
        props.changeFilterModel(filterModel);
      }}
      customChipActions={{
        label:
          mappedFilters.length > 0
            ? t("components.datagrid.filters.clear")
            : t("components.datagrid.filters.allSkills"),
        onClick:
          mappedFilters.length > 0
            ? () => {
              let filterModel = {};
              props.changeFilterModel(filterModel);
            }
            : null,
      }}
    />
  );
};

export default GridFilterChips;
